<div class="main__toolbar-wrapper" ngClass.lt-md="medium-breakpoint">
  <mat-toolbar class="main__toolbar">
    <a [routerLink]="['/dashboard']" class="main__logo-link" ><img src="/assets/images/logo-header.svg"/></a>
  </mat-toolbar>
</div>

<div class="content">
  <ng-container *ngIf="loading">
    <p class="large">Logging in...</p>
    <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
  </ng-container>

  <ng-container *ngIf="!loading && error">
    <p class="large">Unable to log in</p>
    <p class="error">{{ error }}</p>
    <button mat-raised-button color="primary" (click)="retry()">Try again</button>
  </ng-container>
</div>

<mat-toolbar class="main__footer flex-row-start">
  <a href="https://www.globalpeoplestrategist.com/terms-of-use/" target="_blank">Terms of Service</a><span class="main__footer-divider">|</span>
  <a href="https://www.globalpeoplestrategist.com/blog/" target="_blank">Blog</a><span class="main__footer-divider">|</span>
  <a href="mailto:support@globalpeoplestrategist.com">Contact us</a>
</mat-toolbar>
